import React from 'react';
import Navbar from '../components/navbar/Navbar';

const Layout = ({ children }) => {
    return (
        <div className="traceability-app-wrapper">
            <Navbar />
            <div className="traceability-content-body">
                {children}
            </div>
        </div>
    );
};

export default Layout;
